import { FC, PropsWithChildren } from "react";
import { Link } from "react-router-dom";
import styles from "./CustomLink.module.css";

export type PropsCustomLink = PropsWithChildren & {
  to: string;
  onClick?: React.MouseEventHandler<HTMLAnchorElement> | undefined;
};

const CustomLink: FC<PropsCustomLink> = ({ to, onClick, children }) => {
  return (
    <Link
      className={styles.link}
      to={to}
      onClick={(e) => {
        e.stopPropagation();
        onClick?.(e);
      }}
    >
      {children}
    </Link>
  );
};

export default CustomLink;
